// Selected transactions — confirmed-closed Daksfirst deals (GREEN G19).
// Add new closed deals here. All must be GREEN-verified before publishing.

export const transactions = [
  {
    jurisdiction: "UAE",
    sector: "Oil, Gas and Infrastructure",
    structure: "Convertible loan",
    amount: "AED 27 m",
    year: "—",
    status: "Closed"
  },
  {
    jurisdiction: "UAE",
    sector: "Oil and Gas",
    structure: "Receivables purchase",
    amount: "AED 16 m",
    year: "—",
    status: "Closed"
  }
];
